module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel no-margin",
    class: [_vm.event.color],
    on: {
      "click": _vm.showEventDetails
    }
  }, [_c('div', {
    staticClass: "panel-heading event-title",
    class: {
      'clickable-event': _vm.isDaySelected
    }
  }, [_vm._v(_vm._s(_vm.event.title))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30d65447"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/EventCard.vue
// module id = 141
// module chunks = 0 1